import { UseQueryResult, useQuery } from 'react-query'

import { QueryKey } from '@/configs/queryKeys'
import { IListarErrosItensVendaResultado } from '@/interfaces/pedidos'
import {  getListarItensVendasComErro } from '@/services/pedidos'

export function useGetListarItensVendaErro({
  params
}: {
  params: {
    inicio: number
    comprimento: number
    procurar?: string
    idPedidoVenda: string
    IdOperadora: string
    campo?: string
    direcao: string
  }
}): UseQueryResult<IListarErrosItensVendaResultado> {
  return useQuery([QueryKey.listarVendasErro, { params }], getListarItensVendasComErro, {
    enabled: !!params.idPedidoVenda,
    retry: true,
    keepPreviousData: false,
    cacheTime: 0
  })
}
